import { createElement } from 'rax';
import { FieldElement } from '../field';
import NumberPicker from '../number-picker';
export default class NumberPickerField extends FieldElement {
    renderControl() {
        return <NumberPicker {...this.getProps()}/>;
    }
}
NumberPickerField.displayName = 'NumberPickerField';
